import React from 'react';
import { CardFooter } from '../Card/index.js';
export function ModalFooter({ addClassName, ...passThrough }) {
    return React.createElement(CardFooter, { addClassName: `${addClassName || ''} twds-py-3`, ...passThrough, noDivider: false });
}
//# sourceMappingURL=ModalFooter.js.map